// extracted by mini-css-extract-plugin
module.exports = {"box":"box-AM5KiEiC","ad_box":"ad_box-RZgJ3CCU clearfix","fl":"fl-2DWlmLVm fl","fr":"fr-1FQ8sgm5 fr","ad":"ad-H8PIhc_2"};